import type { AppRouteConfig } from '../../models'

import { FeatureIdEnum } from '../../enums'

import { PromotionsForm, PromotionsList } from '../../views'

import { ROUTER_CONSTS } from '../router.consts'
import { ACTIVE_FILTER_CONFIG } from '../routes.filters'
import { ROUTES_PATHS } from '../routes.paths'

export const PROMOTIONS_PATHS = Object.assign(ROUTES_PATHS, {
  promotions: 'promotions',
})

export const PROMOTIONS_EXTRA_FILTERS = {
  [ACTIVE_FILTER_CONFIG.id]: ACTIVE_FILTER_CONFIG,
}

export const PROMOTIONS_ROUTES: AppRouteConfig[] = [
  {
    name: ROUTER_CONSTS.routes[FeatureIdEnum.PROMOTION].list,
    path: PROMOTIONS_PATHS.promotions,
    component: PromotionsList,
    meta: {
      featureId: FeatureIdEnum.PROMOTION,
      filters: () => ({
        regularFiltersEnabled: true,
        extra: PROMOTIONS_EXTRA_FILTERS,
      }),
      style: {
        removeContentPadding: true,
      },
    },
  },
  {
    name: ROUTER_CONSTS.routes[FeatureIdEnum.PROMOTION].create,
    path: `${PROMOTIONS_PATHS.promotions}/${PROMOTIONS_PATHS.actions.create}`,
    component: PromotionsForm,
    meta: {
      featureId: FeatureIdEnum.PROMOTION,
      titleI18nKey: 'createPromotion',
      parentRouteName: ROUTER_CONSTS.routes[FeatureIdEnum.PROMOTION].list,
    },
  },
  {
    name: ROUTER_CONSTS.routes[FeatureIdEnum.PROMOTION].update,
    path: `${PROMOTIONS_PATHS.promotions}/${PROMOTIONS_PATHS.actions.update}`,
    component: PromotionsForm,
    meta: {
      featureId: FeatureIdEnum.PROMOTION,
      titleI18nKey: 'updatePromotion',
      parentRouteName: ROUTER_CONSTS.routes[FeatureIdEnum.PROMOTION].list,
    },
  },
]
